import { render, staticRenderFns } from "./kxxNews.vue?vue&type=template&id=5148c0b3&scoped=true"
import script from "./kxxNews.vue?vue&type=script&lang=js"
export * from "./kxxNews.vue?vue&type=script&lang=js"
import style0 from "./kxxNews.vue?vue&type=style&index=0&id=5148c0b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5148c0b3",
  null
  
)

export default component.exports